import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "../store/index";

import Offboarding from "../pages/Admin/Offboarding";
import  AppLayout  from "../components/AppLayout";

import UserView from "../pages/UserView/UserView";

import {Dashboard} from '../pages/Dashboard/index';

import {SettingsPage} from '../pages/Settings/index';
import {ProfilePage} from '../pages/Profile/index';
import {NotificationsPage} from '../pages/Notifications/NotificationsPage';
import ProjectList from '../pages/Project/index';
import {ProjectForm} from '../pages/Project/ProjectForm'
import {ProjectDetails} from '../pages/Project/ProjectDetails';
import ProjectReviewList from '../pages/Project/ProjectReviewList';
import ComplianceDashboard from "../pages/Admin/ComplianceDashboard";
import ForgotPasswordPage from "../pages/ForgotPasswordPage";
import ResetPasswordPage from "../pages/ResetPasswordPage";
import {MilestoneInvoiceTracker} from "../pages/MilestoneInvoiceTracker/index";
import {AdminUserManagement} from "../pages/AdminUserManagement";
import {AccountsPage} from "../pages/Accounts/index";
import {ConfigurationPage} from "../pages/Configuration/index";
import {SecurityQuestionsPage} from "../pages/SecurityQuestions/index";
import Login from "../pages/Login/index" // ✅ Import Login page
import ChangePasswordPage from "../pages/ChangePasswordPage";
import {Profile} from "../pages/Profile/index";
import LeadershipAttentionView from "../pages/Dashboard/partials/LeadershipAttentionView";
import {InvoiceSetupImport} from "../pages/MilestoneInvoiceTracker/InvoiceSetupImport.jsx"

import PasswordChangedPage from "../pages/PasswordChangedPage"; // ✅ Import Password Changed page
import {ProjectSetupImport} from "../pages/ProjectSetupImport";
import SkillRepo from "../components/SkillsetRepository/SkillRepo";
import EditSkillRepo from "../components/SkillsetRepository/EditSkillRepo";
import ResetLogin from "../components/Login/ResetLogin";
import {Register} from "../pages/Registration";

import {useAuth} from "../hooks/useAuth";


import TrainingPortal from "../pages/Admin/TrainingPortal";
import UserTrainingSearch from "../pages/UserTrainingSearch";
import UserAttendedTrainings from "../pages/UserView/User_Attended/UserAttendedTrainings";
// const submoduleDeployment = process?.env?.SUB_APP_DEPLOYMENT === 'YES'

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ProjectReview } from "../pages/Project/ProjectReview.jsx";
import NotFoundPage from "../pages/NotFound/NotFoundPage";
import ErrorBoundary from "../components/ErrorBoundary/ErrorBoundary";

 
const submoduleDeployment = 'YES'

 const queryClient = new QueryClient();
 

export const subRoute1 = [
  {
    path: "/",
    element:(<QueryClientProvider client={queryClient}><Login /></QueryClientProvider>),
  },
 
  {
    path: "/dashboard",
    element:(<Provider store={store}><QueryClientProvider client={queryClient}><AppLayout ><Dashboard /></AppLayout></QueryClientProvider></Provider>),
  },
  {
    path:"/leadership-attention",
    element:(<Provider store={store}><QueryClientProvider client={queryClient}><AppLayout ><LeadershipAttentionView/></AppLayout></QueryClientProvider></Provider>),
  },
  {
    path: "/register",
    element:(<Provider store={store}><QueryClientProvider client={queryClient}><Register  /></QueryClientProvider></Provider>),
  },
  {
    path:"/admin/users",
    element:(<Provider store={store}><QueryClientProvider client={queryClient}><AppLayout ><AdminUserManagement /></AppLayout></QueryClientProvider></Provider>),
  },
  {
    path:"/notifications",
     element:(<Provider store={store}><QueryClientProvider client={queryClient}><AppLayout ><NotificationsPage /></AppLayout></QueryClientProvider></Provider>),
  },
  {
    path:"/accounts",
     element:(<Provider store={store}><QueryClientProvider client={queryClient}><AppLayout ><AccountsPage /></AppLayout></QueryClientProvider></Provider>),
  },
   {
    path:"/security-questions",
     element:(<Provider store={store}><QueryClientProvider client={queryClient}><AppLayout ><SecurityQuestionsPage /></AppLayout></QueryClientProvider></Provider>),
  },
   {
   path:"/projects/:id",
    element:(<Provider store={store}><QueryClientProvider client={queryClient}><AppLayout ><ProjectDetails  /></AppLayout></QueryClientProvider></Provider>),
  },
  {
   path:"/projects/:id/edit",
    element:(<Provider store={store}><QueryClientProvider client={queryClient}><AppLayout ><ProjectForm /></AppLayout></QueryClientProvider></Provider>),
  },
  {
   path:"/projects/new",
    element:(<Provider store={store}><QueryClientProvider client={queryClient}><AppLayout ><ProjectForm /></AppLayout></QueryClientProvider></Provider>),
  },
   {
    path: "/projects",
    element:(<Provider store={store}><QueryClientProvider client={queryClient}><AppLayout ><ProjectList /></AppLayout></QueryClientProvider></Provider>),
  },
   {
    path: "/configuration",
    element:(<Provider store={store}><QueryClientProvider client={queryClient}><AppLayout ><ConfigurationPage  /> </AppLayout></QueryClientProvider></Provider>),
  },
   {
    path: "/profile",
    element:(<Provider store={store}><QueryClientProvider client={queryClient}><AppLayout ><Profile  /> </AppLayout></QueryClientProvider></Provider>),
  },
  {
    path: "/settings",
    element:(<Provider store={store}><QueryClientProvider client={queryClient}><AppLayout ><SettingsPage /></AppLayout></QueryClientProvider></Provider>),
  },
   {
    path: "/review-list",
    element:(<Provider store={store}><QueryClientProvider client={queryClient}><AppLayout ><ProjectReviewList /></AppLayout></QueryClientProvider></Provider>),
  },
     {
    path: "/review",
    element:(<Provider store={store}><QueryClientProvider client={queryClient}><AppLayout ><ProjectReview /></AppLayout></QueryClientProvider></Provider>),
  },
  {
    path: "/import",
    element:(<Provider store={store}><QueryClientProvider client={queryClient}><AppLayout ><ProjectSetupImport /></AppLayout></QueryClientProvider></Provider>),
  },
  {
    path: "/tracker",
    element:(<Provider store={store}><QueryClientProvider client={queryClient}><AppLayout ><MilestoneInvoiceTracker /></AppLayout></QueryClientProvider></Provider>),
  },
  {
    path:"/tracker/invoice-upload",
    element:(<Provider store={store}><QueryClientProvider client={queryClient}><AppLayout ><InvoiceSetupImport/></AppLayout></QueryClientProvider></Provider>),
  },
  {
    path: "/projects/:id",
    element: (<Provider store={store}><QueryClientProvider client={queryClient}><AppLayout ><ProjectDetails /></AppLayout></QueryClientProvider></Provider>),
  },
  // {
  //   path: "/forgot-password",
  //   element: <ForgotPasswordPage />,
  // },
  // {
  //   path: "/reset-password/:token",
  //   element: <ResetPasswordPage />,
  // },

  // {
  //   path: "/reset-login",
  //   element: <ResetLogin />,
  // },

  // {
  //   path: "/reset-password",
  //   element: <ResetPasswordPage />,
  // },


  // {
  //   path: "/change-password",
  //   element: <ChangePasswordPage />,
  // },


  // {
  //   path: "/password-changed",
  //   element: <PasswordChangedPage />, // ✅ Correct JSX usage
  // },
   
//   {
//     path: "/offboarding/:userToken",
//     element: <Offboarding/>
//   },
// /* User View Onboarding Page*/
//   {
//     path: "/UserView",
//     element: <UserView />
//   },
//   /* User View skillset Page*/
//   {
//     path: "/SkillRepo",
//     element: <SkillRepo/>
//   },
  

//   {
//     path: "/EditSkillRepo",
//     element: <EditSkillRepo/>
//   },
    
//   {
//     path: "/attendedtrainings",
//     element:
//       <UserAttendedTrainings/>
//   },

//   {
//     path: "/training/trainingportal",
//     element:<TrainingPortal/>
//   },
//   /* Compliance dashboard Page*/
//   {
//     path: "/dashboard/compliance-dashboard",
//     element: <ComplianceDashboard />
//   }
];





if(submoduleDeployment) {
  subRoute1.forEach(sr => {
    sr.path = sr.path.substring(1,sr.path.length)
  })
}
// Added after the prefix stripping above so the "*" path is not reduced to "".
subRoute1.push({
  path: "*",
  element: <NotFoundPage />,
});
const router = createBrowserRouter(subRoute1);
function Path() {

  return  <ErrorBoundary><RouterProvider router={router} /></ErrorBoundary>;
}
 



export default Path;
